
import BoxInfoNewComponent from "../../../components/box_infos/New.vue";

export default {
  components: {
    BoxInfoNewComponent
  }
};
